export enum CriteriaConfigType {
  ACTIVITY_ELIGIBILTY = "ACTIVITY_ELIGIBILTY",
  SELECTION_ACTOR = "SELECTION_ACTOR",
  EXHIBITOR_SPONSOR_LIST_ACTOR = "EXHIBITOR_SPONSOR_LIST_ACTOR",
  INVENTORY_ELIGIBILITY = "INVENTORY_ELIGIBILITY"
}
